module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VGDRINSECT-22d61ed127e49b0750fdfd59af077196.png";